const getItemFromSessionStorage = (item) => {
  try {
    return sessionStorage.getItem(item);
  } catch (e) {
    return null;
  }
};

export default getItemFromSessionStorage;
